// Smart Sash Admin Panel - Footer Component
// Application footer

import React from 'react';

/**
 * Footer Component
 */
export const Footer: React.FC = () => {
  const appVersion = __APP_VERSION__;

  return (
    <footer className="bg-white border-top py-3 mt-auto">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start">
            <p className="text-muted small mb-0">
              &copy; {new Date().getFullYear()} H. H. Hawkins Ltd. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <p className="text-muted small mb-0">
              Version {appVersion} |{' '}
              <a href="#" className="text-muted">
                Support
              </a>{' '}
              |{' '}
              <a href="#" className="text-muted">
                Privacy
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
